import MainNavbarComponent from './MainNavbar.component';

export default function MainNavbarContainer() {
  return (
    <MainNavbarComponent />
  );
}
